import { render } from "./PengumumanC.vue?vue&type=template&id=3c9febf2"
import script from "./PengumumanC.vue?vue&type=script&lang=js"
export * from "./PengumumanC.vue?vue&type=script&lang=js"

import "./PengumumanC.vue?vue&type=style&index=0&id=3c9febf2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__